// extracted by css-extract-rspack-plugin
export default {"cls1":"CreateSocialItem-cls1_6fW","cls2":"CreateSocialItem-cls2_Ely CreateSocialItem-cls1_6fW"};